// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1RaAS","select":"Header_select__2ObAo","clinic":"Header_clinic__1wbmX"};